import React from 'react'

import { Formik, Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Col, Button } from '_zari/core'

import * as MarcasService from 'services/marca.service'

const NuevaMarcaModal = ({ show, handleClose, editData, tablaRef }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      nombre: editData.nombre
    }
  }, [editData])

  const onSubmit = React.useCallback(
    async data => {
      if (editData.nombre !== '') {
        MarcasService.actualizarMarca(editData.id, data).then(() => {
          __zariContext.snack('success', 'Marca actualizada')
          handleClose()
        })
        tablaRef.current.reload()
      } else {
        MarcasService.insertarMarca(data).then(() => {
          __zariContext.snack('success', 'Marca creada.')
          handleClose()
        })
        tablaRef.current.reload()
      }
    },
    [__zariContext,editData, handleClose, tablaRef]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>{editData.title}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, handleSubmit }) => (
          <Form>
            <Modal.Body>
              <Form.Group>
                <Form.Label text='NOMBRE' md={4} alignRightAt='md' />
                <Col md={8}>
                  <Field name='nombre'>
                    {({ field }) => (
                      <Form.InputText {...field} isInvalid={touched.nombre && errors.nombre} disabled={isSubmitting} id='input-nombre' />
                    )}
                  </Field>
                </Col>
                {touched.nombre && errors.nombre ? <Form.Feedback type='invalid'>{errors.nombre}</Form.Feedback> : null}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClose}>Cancelar</Button>
              <Button onClick={handleSubmit}>Guardar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(NuevaMarcaModal)
